/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState } from 'react';
import { Input, Button, Segment, Form } from 'semantic-ui-react';

import { t } from '../locales/i18n';
import { useForm, saveRestApiForm } from '@nextinq.public/usable-form';
import { InputWrapper } from '@nextinq/ui-toolkit';

import { userSigninAC } from '../action-creators';
import { useDispatch } from 'react-redux';
import { errorFromMessage } from '../utils/errors';
import { signin } from '../api';
import { setItem } from '../db';

interface SigninPageProps {
  fields?: any;
  handleSubmit?: any;
  error?: any;
  submitting?: any;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function SigninPage(props: SigninPageProps) {
  const [isUpdating, setUpdating] = useState(false);
  const formProps = useForm({ initialValues: { username: '', password: '' } });

  const { setupField, setupWrapper, formValues, formState } = formProps;
  const dispatch = useDispatch();
  const onSubmit = useCallback(() => {
    saveRestApiForm({
      action: async () => {
        dispatch(userSigninAC(formValues));
        const result = await signin(formValues);
        const { token } = result.data;
        if (!token) {
          throw new Error('Invalid token');
        }
        await setItem('token', token);
        window.location.href = '/';
      },
      onError: () => {
        formState.setFormErrors([
          errorFromMessage('password', 'Invalid username or password')
        ]);
      },
      setUpdating
    });
  }, [dispatch, formState, formValues]);
  return (
    <div className="app-container">
      <Segment className="paper-main">
        <h1>{t('Sign in')}</h1>
        <Form onSubmit={onSubmit}>
          <InputWrapper {...setupWrapper('username')}>
            <Input {...setupField('username')} />
          </InputWrapper>
          <InputWrapper {...setupWrapper('password')}>
            <Input {...setupField('password')} type="password" />
          </InputWrapper>
          <Button
            icon="sign-in"
            disabled={isUpdating}
            content={t('Sign in')}
            className="submit-button"
            type="submit"
            primary
          />
        </Form>
      </Segment>
    </div>
  );
}
